function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.52563 12.8601H15.6198L21.1668 23.9326H13.0709L7.52563 12.8601Z",
  fill: "#0D6FAB"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.36685 11.1593H16.7337L24 0.134766H15.6331L8.36685 11.1593ZM0 24.0001H8.36685L15.6331 12.8396H7.26631L0 24.0001Z",
  fill: "#DB8135"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.01685 0H10.8262L16.1763 11.1592H8.36689L3.01685 0Z",
  fill: "#0D6FAB"
});
function SvgLogoCaixa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCaixa);
export default __webpack_public_path__ + "static/media/logo-caixa.20eac11d6016c8f9f6b56e2bef1aba68.svg";
export { ForwardRef as ReactComponent };